import React from 'react';
import {
    Box,
    Typography,
    Paper,
    Divider,
    Button,
} from '@mui/material';
import { LocationOn, PermPhoneMsg } from '@mui/icons-material';
import L from 'leaflet';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const MapCedro = ({ businesses }) => {
    const position = [-6.6000, -39.0600];

    const validBusinesses = businesses.filter(
        business => 
            Array.isArray(business.position) && 
            business.position.length === 2 && 
            business.visible === true
    );

    const formatBusinessTypes = (types) => {
        if (!types || types.length === 0) return 'Nenhum tipo selecionado';
        if (types.length === 1) return types[0].charAt(0).toUpperCase() + types[0].slice(1);
        if (types.length === 2) {
            return `${types[0].charAt(0).toUpperCase() + types[0].slice(1)} e ${types[1].charAt(0).toUpperCase() + types[1].slice(1)}`;
        }
        const formattedTypes = types.map(type => type.charAt(0).toUpperCase() + type.slice(1));
        return `${formattedTypes.slice(0, -1).join(', ')} e ${formattedTypes[formattedTypes.length - 1]}`;
    };

    return (
        <Paper
            elevation={6}
            sx={{
                height: { xs: '75vh', sm: '70vh', md: '70vh' },
                width: '100%',
                borderRadius: 4,
                overflow: 'hidden',
            }}
        >
            <MapContainer
                center={position}
                zoom={15}
                style={{ height: '100%', width: '100%' }}
            >
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                />

                {validBusinesses.map(business => (
                    <Marker key={business.id} position={business.position}>
                        <Popup>
                            <Box sx={{ p: 1, maxWidth: { xs: '250px', sm: '300px' } }}>
                                <Typography
                                    variant="subtitle1"
                                    sx={{
                                        fontWeight: 'bold',
                                        color: '#10641c',
                                        fontSize: { xs: '0.9rem', sm: '1rem' },
                                    }}
                                >
                                    {business.name}
                                </Typography>
                                <Divider sx={{ my: 1 }} />
                                <Box sx={{ mb: 1 }}>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            ml: 1,
                                            fontSize: { xs: '0.8rem', sm: '0.875rem' },
                                        }}
                                    >
                                        {formatBusinessTypes(business.types)}
                                    </Typography>
                                </Box>
                                <Typography
                                    variant="caption"
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        overflowWrap: 'break-word',
                                        fontSize: { xs: '0.7rem', sm: '0.75rem' },
                                    }}
                                >
                                    <LocationOn sx={{ fontSize: { xs: 14, sm: 16 }, mr: 0.5, color: '#10641c' }} />
                                    {business.neighborhood}
                                </Typography>
                                <Typography
                                    variant="caption"
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        overflowWrap: 'break-word',
                                        fontSize: { xs: '0.7rem', sm: '0.75rem' },
                                    }}
                                >
                                    <LocationOn sx={{ fontSize: { xs: 14, sm: 16 }, mr: 0.5, color: '#10641c' }} />
                                    {"Lat: "+String(business.position[0]) + ' Lng:' + String(business.position[1])}
                                </Typography>
                                {/* {business.phone !== '' && (
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        onClick={() => window.open(`https://api.whatsapp.com/send?phone=%2B55${business.phone}`)}
                                        sx={{
                                            mt: 1,
                                            borderColor: '#10641c',
                                            color: '#10641c',
                                            fontSize: { xs: '0.7rem', sm: '0.875rem' },
                                        }}
                                        startIcon={<PermPhoneMsg />}
                                    >
                                        Entrar em Contato
                                    </Button>
                                )} */}
                            </Box>
                        </Popup>
                    </Marker>
                ))}
            </MapContainer>
        </Paper>
    );
};

export default MapCedro;